document.addEventListener("DOMContentLoaded", function() {
    const images = document.querySelectorAll('img[loading="lazy"]');
    const windowHeight = window.innerHeight;

    images.forEach(img => {
        if (img.getBoundingClientRect().top <= windowHeight) {
            img.setAttribute('loading', 'eager'); // Change to eager loading for above-the-fold images
        }
    });
});